import { useSelector } from "react-redux"
import styled from "styled-components"

const LogoContainer = styled.div`
    .navbar-logo__container{
        display: flex;
    }
`
const Logo = styled.div`
    ${props => props.url ? `background-image: url(/image/org/${props.url}.png);` : "" }
    /* background-color: gray; */
    background-size: 100% 100%;
    width: 40px;
    height: 40px;
`
const LogoDesc = styled.div`
    margin-left: 12px;
    font-size: 16px;
    padding-top: 3px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    @media only screen and (max-width: 768px) {
        display: none;
    }
`

export default function Index(props) {
    const acc = useSelector(state => state.acc)
    return (
        <LogoContainer className="navbar-logo">
            <div className="navbar-logo__container">
                <div className="navbar-logo__image">
                    <Logo url={acc.org_name ? acc.org_name : false}/>
                </div>
                <LogoDesc className="navbar-logo__desc">
                    <span><b>{acc.org_disp_name ? acc.org_disp_name : "  "}</b></span>
                </LogoDesc>
            </div>
        </LogoContainer>
    )
}
